import React from 'react';
import '../images/cover-lets-celebrate.png';

const SiteAddOnConfig = () => {
    const code = `
    <div id="fb-root"></div>

    <div id="fb-customer-chat" class="fb-customerchat">
    </div>
    <script>
      var chatbox = document.getElementById('fb-customer-chat');
      chatbox.setAttribute("page_id", "215762731609721");
      chatbox.setAttribute("attribution", "biz_inbox");
    </script>

    <script>
      window.fbAsyncInit = function() {
        FB.init({
          xfbml            : true,
          version          : 'v18.0'
        });
      };

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    </script>
    
    <script>
        var gtmKey = '';
          if(window.location.hostname === 'letscelebrate.vn') {
            gtmKey = 'GTM-5CLXRXBS';
          }
          if (window.location.hostname === 'letscelebrate.io') {
            gtmKey = 'GTM-NKT9WRJK'
          }
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', gtmKey)
    </script>
    `;

    return <div dangerouslySetInnerHTML={{ __html: code }} />;
};
export default SiteAddOnConfig;